import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'
import { BaseText, BaseView } from '@/components/base'
import { useTranslation } from 'react-i18next'

const RecoverPasswordWithEmailHeader = () => {
  const { t } = useTranslation()
  // TODO: add back button text?
  return (
    <BaseView gap={20}>
      <StickyHeaderNavigation />
      <BaseText fontSize={32} fontFamily="semibold">
        {t('screens:forgotPassword.title', { method: t('form:actions.email') })}
      </BaseText>
    </BaseView>
  )
}

export default RecoverPasswordWithEmailHeader
